// city.js - Region data (static fallback + API refresh)
import axios from 'axios'

// Static fallback data (unchanged from original)
const cities =  [
	
]

function flattenToCities(provinces) {
    const result = []
    for (const p of provinces) {
        for (const c of (p.cities || [])) {
            result.push({
                name: c.name,
                districts: c.districts || []
            })
        }
    }
    return result
}

async function fetchCities() {
    try {
        const res = await axios.get('/region/tree')
        if (res.data && res.data.status === 0 && res.data.data) {
            const flatCities = flattenToCities(res.data.data)
            // Update cities array in-place so existing references stay valid
            cities.splice(0, cities.length, ...flatCities)
            return flatCities
        }
    } catch (e) {
        console.warn('Failed to fetch region tree, using local data', e)
    }
    return cities
}

export {
    cities,
    fetchCities
}
